import type { PropsWithChildren} from 'react';
import React, { useEffect, useRef, useState } from 'react';

interface IProps {
  isOpen: boolean;
  duration?: number;
}

export default function AnimateHeight(props: PropsWithChildren<IProps>) {
  const ref = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(props.isOpen);

  useEffect(() => {
    if (!ref.current) return;
    if (isOpen === props.isOpen) return;
    // setIsOpen(props.isOpen);

    const duration = props.duration || 300;
    const elStyles = window.getComputedStyle(ref.current);
    const elHeight = parseFloat(elStyles.getPropertyValue('height'));
    const elPaddingTop = parseFloat(elStyles.getPropertyValue('padding-top'));
    const elPaddingBottom = parseFloat(elStyles.getPropertyValue('padding-bottom'));
    const elMarginTop = parseFloat(elStyles.getPropertyValue('margin-top'));
    const elMarginBottom = parseFloat(elStyles.getPropertyValue('margin-bottom'));

    const stepHeight = elHeight / duration;
    const stepPaddingTop = elPaddingTop / duration;
    const stepPaddingBottom = elPaddingBottom / duration;
    const stepMarginTop = elMarginTop / duration;
    const stepMarginBottom = elMarginBottom / duration;

    let start: number | undefined;

    window.requestAnimationFrame(animationStep);

    function animationStep(timestamp: number) {
      if (start === undefined) start = timestamp;

      const elapsed = timestamp - start;
      if (props.isOpen) {
        ref.current!.style.height = stepHeight * elapsed + 'px';
        ref.current!.style.paddingTop = stepPaddingTop * elapsed + 'px';
        ref.current!.style.paddingBottom = stepPaddingBottom * elapsed + 'px';
        ref.current!.style.marginTop = stepMarginTop * elapsed + 'px';
        ref.current!.style.marginBottom = stepMarginBottom * elapsed + 'px';
      } else {
        ref.current!.style.height = elHeight - stepHeight * elapsed + 'px';
        ref.current!.style.paddingTop = elPaddingTop - stepPaddingTop * elapsed + 'px';
        ref.current!.style.paddingBottom = elPaddingBottom - stepPaddingBottom * elapsed + 'px';
        ref.current!.style.marginTop = elMarginTop - stepMarginTop * elapsed + 'px';
        ref.current!.style.marginBottom = elMarginBottom - stepMarginBottom * elapsed + 'px';
      }

      if (elapsed >= duration) {
        ref.current!.style.height = '';
        ref.current!.style.paddingTop = '';
        ref.current!.style.paddingBottom = '';
        ref.current!.style.marginTop = '';
        ref.current!.style.marginBottom = '';
        ref.current!.style.overflow = '';
        setIsOpen(props.isOpen);
      } else {
        window.requestAnimationFrame(animationStep);
      }
    }
  }, [isOpen, props.duration, props.isOpen]);

  return (
    <div ref={ref} className={`hidden overflow-hidden ${isOpen || props.isOpen ? '!block' : ''}`}>
      {props.children}
    </div>
  );
}
